import React from "react";
import PropTypes from "prop-types";
import { Tab as SemanticTab } from "semantic-ui-react";
import "./HATab.scss";

export const HATab = ({
  disabled = false,
  type = "prod-hd-02",
  bottomMargin = true,
  alt = false,
  panes = [],
  ...props
}) => {
  return (
    <SemanticTab
      className={`hireart-ds-tab ${alt ? "alt" : ""} ${
        !bottomMargin && "no-margin-bottom"
      } ${disabled && "disabled"} ${type}`}
      menu={{ secondary: true, pointing: true }}
      panes={panes}
      {...props}
    />
  );
};

HATab.propTypes = {
  disabled: PropTypes.bool,
  bottomMargin: PropTypes.bool,
  alt: PropTypes.bool,
  panes: PropTypes.array,
  type: PropTypes.oneOf([
    "prod-hd-03",
    "prod-hd-02",
    "prod-hd-01",
    "body-short-02",
    "body-short-01",
  ]),
};

